export enum StorageKey {
  INSURANCE_LIST_DEFAULT_QUERY_PARAMS = '____InsuranceListDefaultQueryParams____'
}
